<template>
  <div class="entrustform">
    <div class="w12">
      <endetfripro />
      <enformzw class="mt30" />
    </div>
  </div>
</template>

<script>
import endetfripro from "views/entrustdet/components/endetfripro";
import enformzw from './child/enformzw'
export default {
  components: {
    endetfripro,
    enformzw,
  },
};
</script>

<style lang="scss" scoped>
.entrustform {
  background-color: #f8f8f8;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
  }
}
</style>